import imageInput from "@/mixins/image-input";
import ProductPostModel from "@/views/product/models/product-post.model";

export default {
    name: "product-add",
    data() {
        return {
            item: {}
        }
    },
    computed: {
        isEditPage() {
            return this.$route.meta.edit;
        },
    },
    methods: {
        approve() {
            let data = new ProductPostModel(this.item);
            let formData = new FormData();
            for (let key in data) {
                formData.append(key, data[key]);
            }
            if (this.isEditPage) {
                this.$store.dispatch("product/updateItem", {id: data.id, data: formData});
            } else {
                this.$store.dispatch("product/setItem", formData).then((res) => {
                    if (res) {
                        this.item = {};
                        this.resfresh = true;
                    }
                });
            }
        },
    },
    created() {
        let id = this.$route.params.id;
        if (this.isEditPage) {
            this.$store.dispatch("product/getItemById", id).then((res) => {
                if (res) {
                    this.item = res;
                }
            });
        }
    },
    mixins: [imageInput]
};
